export default "__VITE_ASSET__DAlwbKLl__"